;(() => {
  // var localPath = window.location.pathname.replace(/\/fr\/|\/es\/|\/it\/|\/de\/|\/ar\//, '/').replace(/(\/fr|\/es|\/it|\/de|\/ar)$/, '/')
  const hrefs = document.querySelectorAll('.as-user-icon')
  for (let i = 0; i < hrefs.length; i++) {
    const href = hrefs[i].href
    if (href.indexOf('/?__current_page__') > -1 || href.indexOf('?__current_page__') > -1 || href.indexOf('__return_to_current_page__') > -1) {
      hrefs[i].href =
        href
          // 完成跳转到其他商城进入相同页面
          // .replace('/?__current_page__', localPath + window.location.search)
          // .replace('?__current_page__', localPath + window.location.search)
          // 完成进入本商城其他页面带有 return to 小尾巴,以保证完成某项操作后还能跳回来, 比如说登录后跳回本页面
          .replace('__return_to_current_page__', 'return_to=' + window.location.href)
    }
  }

  // 获取地址栏中的查询字符串
  const queryString = window.location.search
  // 使用URLSearchParams对象解析查询字符串
  const searchParams = new URLSearchParams(queryString)
  // 获取 return_to 参数的值
  const returnToValue = searchParams.get('return_to')
  const retrunToLinks = document.querySelectorAll('.as-return-to-link')
  // const backBtns = document.querySelectorAll('.as-back-btn')
  if (returnToValue) {
    retrunToLinks.forEach((retrunToLin) => {
      const href = retrunToLin.href
      retrunToLin.href = href + `?return_to=${returnToValue}`
    })

    // backBtns.forEach((backBtn) => {
    //   backBtn.href = returnToValue
    // })
  }
})()
